// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"d3ddcdb1","626":"d181d427","2275":"f4b13de2","4615":"d181d427"}[chunkId] + ".chunk.css";
};